import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { CUSTOM_FILTERS } from "@/config/list";
import type { ListFilters } from "@/types/list";

type ActiveFilterValue = "all" | "active" | "inactive";

interface AlarmActiveFilterProps {
	filter: ListFilters;
}

const OPTIONS: { value: ActiveFilterValue; label: string }[] = [
	{ value: "all", label: "All" },
	{ value: "active", label: "Active" },
	{ value: "inactive", label: "Inactive" },
];

const readSelected = (raw: unknown): ActiveFilterValue => {
	if (raw === true) return "active";
	if (raw === false) return "inactive";
	return "all";
};

export const AlarmActiveFilter = ({ filter }: AlarmActiveFilterProps) => {
	const value = readSelected(filter.getFilter(CUSTOM_FILTERS.enabled));
	const selectedLabel = OPTIONS.find(option => option.value === value)?.label ?? "All";

	const handleSelect = (next: ActiveFilterValue) => {
		if (next === "all") {
			filter.clearFilter(CUSTOM_FILTERS.enabled);
		} else {
			filter.setFilter(CUSTOM_FILTERS.enabled, next === "active");
		}
	};

	return (
		<div className="relative z-10">
			<div className="flex flex-col space-y-1">
				<span className="text-xs font-medium text-muted-foreground">Status</span>

				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="outline" className="justify-start gap-2">
							<span className={value === "all" ? "font-semibold text-muted-foreground" : "font-semibold"}>
								{selectedLabel}
							</span>
							<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
						</Button>
					</DropdownMenuTrigger>

					<DropdownMenuContent align="start">
						{OPTIONS.map(option => (
							<DropdownMenuItem
								key={option.value}
								onSelect={() => handleSelect(option.value)}
								className={value === option.value ? "font-semibold bg-muted" : ""}
							>
								{option.label}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};
